const listOfLanguages = ['en', 'ja']//, 'ru', 'it'];

export const listLangNames = {
	'en': 'English',
	'ja': 'Japanese'
	// 'ru': 'Русский',
	// 'it': 'Italiano'
};

export default listOfLanguages;